function calculateRankings(data) {
    function toEther(value) {
        let number = ethers.BigNumber.from(value) // eslint-disable-line
        let ether = ethers.utils.formatEther(number) // eslint-disable-line
        ether = (+ether).toFixed(2)
        return Number(ether)
    }

    function sortedAndAddRanking(unsortedData, value) {
        const sorted = unsortedData.sort((a, b) => a[value] - b[value])
        return addRank(sorted, value, `${value}_ranking`)
    }

    function addRank(sortedArr, sourceColumn, newColumn) {
        for (var i = 0; i < sortedArr.length; i++) {
            //
            sortedArr[i][newColumn] =
                i === 0 ||
                sortedArr[i][sourceColumn] !== sortedArr[i - 1][sourceColumn]
                    ? i + 1 // anytime new grade appears, rank=i
                    : sortedArr[i - 1][newColumn] // elseIf: equal grade, then equal rank
        }
        return sortedArr
    }

    const dataWithoutTinyFacesAndNull = data.filter(
        (d) =>
            d.twitter_username !== 'TinyFacesNFT' &&
            d.address !== '0x0000000000000000000000000000000000000000'
    )
    const newData = dataWithoutTinyFacesAndNull.map((d) => {
        return {
            address: d.address,
            name: d.name,
            avatar: d.avatar,
            twitter_name: d.twitter_name,
            twitter_username: d.twitter_username,
            opensea_username: d.opensea_username,
            discord_username: d.discord_username,
            discord: d.discord_karma || 0,
            owns: d.owns || 0,
            avg_listed: toEther(d.opensea_sale_avg_listed || 0),
            gainloss: toEther(d.opensea_sale_difference || 0),
            spend: toEther(d.opensea_sale_spend || 0),
            value: toEther(d.opensea_sale_value || 0),
        }
    })

    sortedAndAddRanking(newData, 'discord')
    sortedAndAddRanking(newData, 'owns')
    sortedAndAddRanking(newData, 'avg_listed')
    sortedAndAddRanking(newData, 'gainloss')
    sortedAndAddRanking(newData, 'spend')
    sortedAndAddRanking(newData, 'value')

    const newDataWithTotalPoints = newData.map((d) => {
        const results = [
            d.discord_ranking,
            d.owns_ranking,
            d.avg_listed_ranking,
            d.gainloss_ranking,
            d.spend_ranking,
            d.value_ranking,
        ]

        const sum = results.reduce((a, b) => a + b, 0) / results.length

        const newRanking = d
        d.ranking_points = sum
        d.ranking_results = results

        return newRanking
    })

    const orderedByRankingPoints = newDataWithTotalPoints.sort(function (a, b) {
        return b.ranking_points - a.ranking_points
    })

    const withRanking = orderedByRankingPoints.map((d, index) => {
        const newRanking = d
        d.ranking = index + 1
        return newRanking
    })

    return withRanking
}

export default calculateRankings
